import type { IconSvgObject } from './types';

const LabelImportantIcon: IconSvgObject = [
  ["path", { d: "M2.83827 5.49026C2.46331 4.82366 2.94502 4 3.70985 4H16.4458C16.7905 4 17.111 4.17762 17.2938 4.47L21.3375 10.94C21.7428 11.5885 21.7428 12.4115 21.3375 13.06L17.2938 19.53C17.111 19.8224 16.7905 20 16.4458 20H3.70985C2.94502 20 2.46331 19.1763 2.83827 18.5097L6.5 12L2.83827 5.49026Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default LabelImportantIcon;
